// extracted by mini-css-extract-plugin
export default {"totalsWrapper":"BudgetEditor-module__totalsWrapper___H4l9b","nbView":"BudgetEditor-module__nbView___i8xpD","textAlignLeft":"BudgetEditor-module__textAlignLeft___LFVt6"};